const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const required = (value) => (String(value ?? "").trim() ? "" : "Campo obrigatório.");
const digits = (value) => String(value ?? "").replace(/\D/g, "");

export function formatCpf(value) {
  return digits(value)
    .slice(0, 11)
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
}

export function formatPhone(value) {
  const phone = digits(value).slice(0, 11);
  if (phone.length <= 10) {
    return phone.replace(/(\d{2})(\d)/, "($1) $2").replace(/(\d{4})(\d)/, "$1-$2");
  }
  return phone.replace(/(\d{2})(\d)/, "($1) $2").replace(/(\d{5})(\d)/, "$1-$2");
}

export function isValidCpf(value) {
  const cpf = digits(value);
  if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;

  const calculateDigit = (length) => {
    let sum = 0;
    for (let index = 0; index < length; index += 1) {
      sum += Number(cpf[index]) * (length + 1 - index);
    }
    const remainder = (sum * 10) % 11;
    return remainder === 10 ? 0 : remainder;
  };

  return calculateDigit(9) === Number(cpf[9]) && calculateDigit(10) === Number(cpf[10]);
}

function validatePersonalData(data) {
  const errors = {};
  ["name", "surname", "ibm", "birthDate", "email", "phone"].forEach((field) => {
    const message = required(data[field]);
    if (message) errors[field] = message;
  });

  if (!/^\d{4,12}$/.test(digits(data.ibm))) errors.ibm = "Informe um IBM válido.";
  if (!isValidCpf(data.cpf)) errors.cpf = "Informe um CPF válido.";
  if (data.email && !EMAIL_PATTERN.test(data.email)) errors.email = "Informe um e-mail válido.";
  if (![10, 11].includes(digits(data.phone).length)) errors.phone = "Informe o celular com DDD.";
  if (data.birthDate && new Date(`${data.birthDate}T12:00:00`) >= new Date()) {
    errors.birthDate = "Informe uma data de nascimento válida.";
  }
  if (!data.hasSpecialNeeds) errors.hasSpecialNeeds = "Selecione uma opção.";
  if (data.hasSpecialNeeds === "sim" && !data.specialNeedsDetails.trim()) {
    errors.specialNeedsDetails = "Descreva a necessidade especial.";
  }
  if (!data.hasHealthPlan) errors.hasHealthPlan = "Selecione uma opção.";
  if (data.hasHealthPlan === "sim" && !data.healthPlanName.trim()) {
    errors.healthPlanName = "Informe o plano de saúde.";
  }
  if (!data.companion) errors.companion = "Selecione uma opção.";
  if (data.companion === "sim") {
    ["companionName", "companionSurname", "companionBirthDate"].forEach((field) => {
      const message = required(data[field]);
      if (message) errors[field] = message;
    });
    if (!isValidCpf(data.companionCpf)) errors.companionCpf = "Informe um CPF válido.";
  }
  return errors;
}

function validateTravelData(data) {
  const errors = {};
  if (!data.originCity.trim()) errors.originCity = "Informe a cidade de origem.";
  if (!data.bedPreference) errors.bedPreference = "Selecione uma opção.";
  if (!data.dietaryRestrictions) errors.dietaryRestrictions = "Selecione uma opção.";
  if (data.dietaryRestrictions === "sim" && !data.dietaryDetails.trim()) {
    errors.dietaryDetails = "Descreva as restrições alimentares.";
  }
  if (!data.hasAccessibilityNeeds) errors.hasAccessibilityNeeds = "Selecione uma opção.";
  if (data.hasAccessibilityNeeds === "sim" && !data.accessibilityDetails.trim()) {
    errors.accessibilityDetails = "Descreva sua necessidade especial.";
  }
  return errors;
}

function validateTerms(data) {
  const errors = {};
  if (!data.acceptPrivacy) errors.acceptPrivacy = "A confirmação de leitura é obrigatória.";
  return errors;
}

export function validateStep(step, data) {
  if (step === 1) return validatePersonalData(data);
  if (step === 2) return validateTravelData(data);
  return validateTerms(data);
}
